import { Link } from "react-scroll";
import ReadMore from 'components/ui/Readmore';
import {CloseIcon} from 'components/custom-icons'

export default function CompanyAboutSection({companyinfo, onClose}) {
  
  const company_basic_info = JSON.parse(companyinfo?.company_basic_info);
  const officer = JSON.parse(companyinfo?.management_data)?? [];
  console.log('management_data:', officer);

  //console.log('management_data officer:', management_data[0]?.officer);

  return (
      <section className="company-profile  bg-white shadow-md z-[999] rounded-xl p-5 w-full">
         <div className="flex border-b-2 py-2 w-full">
          <div className="w-2/3">
              <h2 className="text-3xl font-semibold">About the Company</h2>
          </div>
          <div className="w-1/3 flex justify-end">
             <button aria-label="Close panel" className="z-[60] inline-block outline-none focus:outline-none ltr:right-4 rtl:left-4 border-2 border-black " onClick={onClose}>
              <CloseIcon className="h-6 w-6" />
            </button>
          </div>
        </div>
        <div>
           <p className="text-[0.9375rem] text-base/80">
            {companyinfo?.about}
            </p>
          </div>
        <div className="flex space-x-4 py-2 w-full ">
        {company_basic_info?.address1 && company_basic_info?.address1 != '' ?
            <div className="space-y-2 w-1/2">
            <h4 className="text-xl font-semibold">Registered Office</h4>
              <div>
                <div className="font-semibold">Address</div>
                <div className="w-[40%]">{company_basic_info?.address1}  {company_basic_info?.address2}</div>
              </div>
               <div>
                <div className="font-semibold">City</div>
                <div>{company_basic_info?.city}</div>
              </div>
               <div>
                <div className="font-semibold">Zip</div>
                <div>{company_basic_info?.zip}</div>
              </div>
               <div>
                <div className="font-semibold">Phone No.</div>
                <div>{company_basic_info?.phone}</div>
              </div>
              <div>
                <div className="font-semibold">Fax</div>
                <div>{company_basic_info?.fax}</div>
              </div>
               <div>
                <div className="font-semibold">Website</div>
                <div>{company_basic_info?.website}</div>
              </div>
            </div>
            :
            <div className="flex space-x-4 py-2 w-full ">
            <div className="space-y-2 w-1/2">
            <h4 className="text-xl font-semibold">Registered Office</h4>
            
             <p>Data is not ready yet , Please check again later. </p>
            </div>
            </div>
           }
             <div className="space-y-2 w-1/2">
            <h4 className="text-xl font-semibold">Management</h4>
            {company_basic_info ?
              <>
              {company_basic_info?.companyOfficers?.map((val, key) => (
              <div>
                <div className="font-semibold">{val?.name}</div>
                <div>{val?.title}</div>
              </div>
                ))
              }
              </>
              :
              <>
              {Object.keys(officer || {}).length === 0 ? (
                  <div className="py-2 text-heading"> Data is not ready yet , Please check again later.
                </div>
                    ) : (<>
              {officer?.officer?.map((val, key) => (
              <div>
                <div className="font-semibold">{val?.firstName} {val?.mI} {val?.lastName}</div>
                <div>{val?.title?.Value}</div>
              </div>
                ))
              }
              </>
              )}
              </>
              
            }
                

            </div>
          </div>
          <div >
             {/*companyinfo?.company_basic_info*/}
          </div>
      </section> 
  );
}
